"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlatform = exports.getArch = exports.isknownVersion = exports.validateFileCheckSum = exports.compareVersions = exports.extract = exports.validateChecksum = exports.ComparisonResult = exports.VERSIONS_WHICH_MODIFY_PROFILE = exports.EARLIEST_VERSION_WITH_NO_MODIFY_PATHSUPPORT = exports.RYE_CONFIG_TOML = exports.RYE_CONFIG_TOML_BACKUP = exports.toolsCacheName = exports.OWNER = exports.REPO = exports.WINDOWS_PLATFORMS = exports.WINDOWS_ARCHS = void 0;
const fs = __importStar(require("fs"));
const crypto = __importStar(require("crypto"));
const io = __importStar(require("@actions/io"));
const core = __importStar(require("@actions/core"));
const exec = __importStar(require("@actions/exec"));
const checksums_1 = require("./checksums");
exports.WINDOWS_ARCHS = ['x86', 'x64'];
exports.WINDOWS_PLATFORMS = ['win32', 'win64'];
exports.REPO = 'rye';
exports.OWNER = 'astral-sh';
exports.toolsCacheName = 'setup-rye-2024-03-04'; // Custom name for cache busting
exports.RYE_CONFIG_TOML_BACKUP = 'config.toml.bak';
exports.RYE_CONFIG_TOML = 'config.toml';
exports.EARLIEST_VERSION_WITH_NO_MODIFY_PATHSUPPORT = '0.25.0';
exports.VERSIONS_WHICH_MODIFY_PROFILE = [
    '0.21.0',
    '0.22.0',
    '0.23.0',
    '0.24.0'
];
var ComparisonResult;
(function (ComparisonResult) {
    ComparisonResult[ComparisonResult["Greater"] = 1] = "Greater";
    ComparisonResult[ComparisonResult["Equal"] = 0] = "Equal";
    ComparisonResult[ComparisonResult["Less"] = -1] = "Less";
})(ComparisonResult || (exports.ComparisonResult = ComparisonResult = {}));
function validateChecksum(checkSum, downloadPath, arch, platform, version) {
    return __awaiter(this, void 0, void 0, function* () {
        let isValid = true;
        if (checkSum !== undefined && checkSum !== '') {
            isValid = yield validateFileCheckSum(downloadPath, checkSum);
        }
        else {
            core.debug(`Checksum not provided. Checking known checksums.`);
            const key = `${arch}-${platform}-${version}`;
            if (key in checksums_1.KNOWN_CHECKSUMS) {
                const knownChecksum = checksums_1.KNOWN_CHECKSUMS[`${arch}-${platform}-${version}`];
                core.debug(`Checking checksum for ${arch}-${platform}-${version}.`);
                isValid = yield validateFileCheckSum(downloadPath, knownChecksum);
            }
            else {
                core.debug(`No known checksum found for ${key}.`);
            }
        }
        if (!isValid) {
            throw new Error(`Checksum for ${downloadPath} did not match ${checkSum}.`);
        }
        core.debug(`Checksum for ${downloadPath} is valid.`);
    });
}
exports.validateChecksum = validateChecksum;
function extract(downloadPath) {
    return __awaiter(this, void 0, void 0, function* () {
        core.info('Extracting downloaded archive...');
        const pathForGunzip = `${downloadPath}.gz`;
        yield io.mv(downloadPath, pathForGunzip);
        yield exec.exec('gunzip', [pathForGunzip]);
        yield exec.exec('chmod', ['+x', downloadPath]);
    });
}
exports.extract = extract;
function compareVersions(versionA, versionB) {
    const versionPartsA = versionA.split('.').map(Number);
    const versionPartsB = versionB.split('.').map(Number);
    for (let i = 0; i < versionPartsA.length; i++) {
        if (versionPartsA[i] > versionPartsB[i]) {
            return ComparisonResult.Greater;
        }
        else if (versionPartsA[i] < versionPartsB[i]) {
            return ComparisonResult.Less;
        }
    }
    return ComparisonResult.Equal;
}
exports.compareVersions = compareVersions;
function validateFileCheckSum(filePath, expected) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const hash = crypto.createHash('sha256');
            const stream = fs.createReadStream(filePath);
            stream.on('error', err => reject(err));
            stream.on('data', chunk => hash.update(chunk));
            stream.on('end', () => {
                const actual = hash.digest('hex');
                resolve(actual === expected);
            });
        });
    });
}
exports.validateFileCheckSum = validateFileCheckSum;
function isknownVersion(version) {
    const pattern = new RegExp(`^.*-.*-${version}$`);
    return Object.keys(checksums_1.KNOWN_CHECKSUMS).some(key => pattern.test(key));
}
exports.isknownVersion = isknownVersion;
function getArch() {
    const arch = process.arch;
    core.debug(`Arch: ${arch}`);
    const archMapping = {
        ia32: 'x86',
        x64: 'x86_64',
        arm64: 'aarch64'
    };
    if (arch in archMapping) {
        return archMapping[arch];
    }
}
exports.getArch = getArch;
function getPlatform() {
    const platform = process.platform;
    core.debug(`Platform: ${platform}`);
    if (platform === 'linux') {
        return 'linux';
    }
    else if (platform === 'darwin') {
        return 'macos';
    }
    else if (platform === 'win32') {
        return 'windows';
    }
}
exports.getPlatform = getPlatform;
